// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__B2L1E","list__breadcrumbs":"List_list__breadcrumbs__xkFMh","list__items":"List_list__items__a9_9_","list__item":"List_list__item__0BKkh"};